import { useMutation } from '@apollo/client';
import { RemoveUserFromWaitListDocument } from '@website/types/graphqlOperations';
import { Button, Spinner } from 'react-bootstrap';
import { FaMinusCircle } from 'react-icons/fa';

type Props = {
  groupID: string;
  userID: string;
};

/**
 * Leave WaitList Button
 */
export default function LeaveWaitListButton({ groupID, userID }: Props) {
  const [removeUserFromWaitList, { loading }] = useMutation(
    RemoveUserFromWaitListDocument,
    {
      update(cache, { data }) {
        const waitListCacheID = cache.identify({
          __typename: 'WaitList',
          id: data.removeUserFromWaitList.id,
        });

        cache.evict({
          id: waitListCacheID,
        });
      },
    },
  );

  const removeUser = async () => {
    try {
      await removeUserFromWaitList({
        variables: {
          input: {
            groupID,
            userID,
          },
        },
      });
    } catch (e) {
      if (e.networkError) {
        alert(
          'Internet connection lost - please retry when you are connected.',
        );
      } else {
        alert(e);
      }
    }
  };

  return (
    <>
      <Button
        role="button"
        variant="outline-danger"
        title="Leave Waitlist"
        size="sm"
        onClick={() => removeUser()}
      >
        {loading ? (
          <Spinner
            data-testid="leaving-spinner"
            animation="border"
            size="sm"
            className="me-1"
          />
        ) : (
          <FaMinusCircle data-testid="leave-icon" className="me-1" />
        )}
        <strong>Remove</strong>
      </Button>
    </>
  );
}
